import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './styles/tailwind.css'
import './styles/theme.css'
import { useAuthStore } from './stores/authStore'
import { useNotificationStore } from './stores/notificationStore'
import { initWebSocketAutoConnect, connectWebSocket, disconnectWebSocket, subscribeToKYCNotifications, subscribeToTradeNotifications, subscribeToMarketNotifications } from './composables/useWebSocket'
import { toastSuccess, toastError } from './utils/toast'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Initialize auth store (check token validity)
const authStore = useAuthStore()
authStore.init()

// Initialize notification store
const notificationStore = useNotificationStore()

// Initialize WebSocket after auth store is ready
if (authStore.isLoggedIn) {
  initWebSocketAutoConnect()
  
  // Subscribe to KYC notifications and show toast
  subscribeToKYCNotifications((notification) => {
    const { status, message, kyc_level } = notification.payload
    if (status === 'approved') {
      toastSuccess(`KYC Verified! Your account is now verified at level ${kyc_level}`)
    } else {
      toastError(`KYC Verification Failed: ${message}`)
    }
  })

  // Subscribe to trade notifications and show toast
  // Disabled: user doesn't want notification popup after trade
  // subscribeToTradeNotifications((notification) => {
  //   const { status, message, market_title, side, amount } = notification.payload
  //   if (status === 'completed') {
  //     toastSuccess(`Trade Completed: ${side} ${amount} of ${market_title}`)
  //   } else {
  //     toastError(`Trade Failed: ${message}`)
  //   }
  // })

  // Subscribe to market notifications (close/settle/cancel) and show toast
  subscribeToMarketNotifications((notification) => {
    const { type, title } = notification.payload
    
    // Show toast for market-related notifications
    // Transaction notifications (order confirmed) - don't show toast, modal already shows
    if (type === 'market_settled' || type === 'market_closed' || type === 'market_cancelled') {
      toastSuccess(title)
    } else if (type !== 'transaction') {
      // Only show error toast for other notification types
      toastError(title)
    }
    // Refresh unread count
    notificationStore.fetchUnreadCount()
  })

  // Fetch initial unread count
  notificationStore.fetchUnreadCount()
}

// Listen for storage changes (token changes - e.g., login/logout/refresh)
window.addEventListener('storage', (event) => {
  if (event.key === 'access_token') {
    if (event.newValue) {
      // Token added - connect WebSocket
      connectWebSocket(event.newValue)
    } else {
      // Token removed - disconnect WebSocket
      disconnectWebSocket()
    }
  }
})

app.mount('#app')
